import React from 'react';

import Github from '../components/nav/github.svg'
import Twitter from '../components/nav/twitter.svg'
import Slack from '../components/nav/slack.svg'
import Whatsapp from '../components/nav/whatsapp.svg'

import { useTranslation } from 'react-i18next';
import { sendEventToGA } from '../services/analytics.service';

const handleOnclick  = (app) => {
  sendEventToGA('User', 'Clicked Share/'+ app, app)
}

const SocialFooter = () => {
  const {t} = useTranslation();
  return <div className="social-footer">
    <ul>
      <li><a className="github" target="_blank" rel="noopener noreferrer" onClick={() => handleOnclick('github')} href="https://gitlab.com/Abdul1337/covid-19">
        <img src={Github} alt="github share icon" />
        {t('Contribute on Github')}
        </a></li>
      {/* <li><a className="slack" target="_blank" rel="noopener noreferrer" onClick={() => handleOnclick('slack')} href="https://join.slack.com/t/livecovidin/shared_invite/zt-e10jouqp-HquZhM2L853zaN0JM9S2qg">
        <img src={Slack} alt="slack join" />
        {t('Join on Slack')}
      </a></li> */}
      <li><a className="twitter" target="_blank" rel="noopener noreferrer" onClick={() => handleOnclick('twitter')} href="https://twitter.com/share?text=Covid-19 Live provides the latest state-wise updates on the spread of the coronavirus in India. Stay Informed. Stay Inside!&url=https://covid19-abdul1337.netlify.app/">
        <img src={Twitter} alt="twitter share icon" />
        {t('Share on Twitter')}
        </a></li>
      <li><a className="whatsapp" data-action="share/whatsapp/share" target="_blank" rel="noopener noreferrer" onClick={() => handleOnclick('whatsapp')} href="whatsapp://send?text=Covid-19 Live provides the latest state-wise updates on the spread of the coronavirus in India. Stay Informed. Stay Inside https://covid19-abdul1337.netlify.app/">
        <img src={Whatsapp} alt="whatsapp join" />
        {t('Share on Whatsapp')}
      </a></li>

    </ul>
  </div>
}

export default SocialFooter;